const server = 'https://meter.space-smart.ru';

export default {
    server: server,
    apiHost: `${server}/api`,
    currentOrganizationId: 'ef47f23a-d99d-4ba6-a4dd-07e0660a8f15',
    isProduction: true
}
